import { useQuery } from '@apollo/client'
import { Select, SelectProps } from 'antd'
import React, { useMemo } from 'react'
import { BATIMENTS_QUERY } from '../../apollo/query/batiment.query'
import { D4_Batiment } from '../../types'

const D4SelectBatiment: React.FC<SelectProps<any> & { coproprieteId: number }> = ({ coproprieteId, ...rest }) => {
  const { data: batiments } = useQuery<{ batiments: D4_Batiment[] }, { coproprieteid: number }>(BATIMENTS_QUERY, {
    skip: !coproprieteId,
    variables: { coproprieteid: coproprieteId },
  })

  const batimentOptions = useMemo(
    () => [
      { label: 'Général', value: coproprieteId },
      ...(batiments?.batiments.map((bat) => ({
        label: bat.libelle,
        value: bat.id,
      })) ?? []),
    ],
    [coproprieteId, batiments?.batiments]
  )

  return (
    <Select
      options={batimentOptions}
      showArrow
      showSearch
      optionFilterProp="label"
      style={{ width: '100%' }}
      placeholder="Selectionnez un batiment"
      {...rest}
    />
  )
}

export default D4SelectBatiment
